// extracted by mini-css-extract-plugin
module.exports = {"numericInput":"numericInput_numericInput__2wPMx"};